import { render, staticRenderFns } from "./Autorizador.vue?vue&type=template&id=72d1a38c&scoped=true"
import script from "./Autorizador.vue?vue&type=script&lang=js"
export * from "./Autorizador.vue?vue&type=script&lang=js"
import style0 from "./Autorizador.vue?vue&type=style&index=0&id=72d1a38c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d1a38c",
  null
  
)

export default component.exports